import { request } from '@umijs/max';

const BASE = process.env.Auth_URL || '';

interface Envelope<T> {
  success: boolean;
  data?: T;
  message?: string;
  error?: { code: string; message?: string };
}

export type OrderStatus = 'pending' | 'paid' | 'refunded' | 'failed' | 'expired';

export interface AdminPaymentOrder {
  id: string;
  orderNo: string;
  userId: string;
  source?: string; // custom | pack | manual
  amountCents: number;
  currency: string;
  credits: number;
  status: OrderStatus;
  stripeSessionId?: string;
  stripePaymentIntent?: string;
  stripeCustomerId?: string;
  paidAt?: string;
  refundState?: 'pending' | 'completed' | 'failed';
  refundedAt?: string;
  refundReason?: string;
  refundedBy?: string;
  failureReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListOrdersAdminResponse {
  orders: AdminPaymentOrder[];
  total: number;
  page: number;
  pageSize: number;
}

export async function adminListOrders(params: {
  userId?: string;
  status?: OrderStatus | '';
  page?: number;
  pageSize?: number;
} = {}) {
  return request<Envelope<ListOrdersAdminResponse>>(
    `${BASE}/api/admin/payments/orders`,
    {
      method: 'GET',
      params,
      skipErrorHandler: true,
    },
  );
}

export async function adminGetOrder(orderNo: string) {
  return request<Envelope<AdminPaymentOrder>>(
    `${BASE}/api/admin/payments/orders/${encodeURIComponent(orderNo)}`,
    { method: 'GET', skipErrorHandler: true },
  );
}

export async function adminRefundOrder(orderNo: string, reason: string) {
  return request<Envelope<{ orderNo: string; pending?: boolean }>>(
    `${BASE}/api/admin/payments/orders/${encodeURIComponent(orderNo)}/refund`,
    {
      method: 'POST',
      data: { reason },
      skipErrorHandler: true,
    },
  );
}
